import React from 'react';
import intersection from 'lodash/intersection';
import uniq from 'lodash/uniq';
import { clipsFromClipSlug, clipsFromSceneSlug } from '../../actions/search';
import Layout from '../../components/Layout';
import Browse from './Browse';

async function action(context) {
  let clipClips = Promise.resolve(undefined);
  let sceneClips = Promise.resolve(undefined);

  if (context.params.clipSlug) {
    clipClips = context.store.dispatch(
      clipsFromClipSlug(context.params.clipSlug),
    );
  }

  if (context.params.sceneSlug) {
    sceneClips = context.store.dispatch(
      clipsFromSceneSlug(context.params.sceneSlug),
    );
  }

  clipClips = await clipClips;
  sceneClips = await sceneClips;

  const result = figureItOut(clipClips, sceneClips);

  if (result.redirect !== undefined) {
    return result;
  }

  return {
    chunks: ['browse'],
    title: 'Browse - Storytape',
    description:
      'Be your own director. No more sorting through piles of unusable stock footage. Choose the right clip from intelligently grouped scenes to tell your story.',
    component: (
      <Layout showHeader={false}>
        <Browse clip={result.clip} sceneClips={result.sceneClips} />
      </Layout>
    ),
  };
}

export default action;

function figureItOut(clipClips, sceneClips) {
  // Nothing or just a scene slug...
  if (!clipClips || clipClips.length < 1) {
    if (!sceneClips || sceneClips.length < 1) {
      return { clip: undefined, sceneClips: undefined };
    } else {
      return {
        clip: undefined,
        sceneClips: sceneClips.filter(
          clip => clip.scene_id === sceneClips[0].scene_id,
        ),
      };
    }
  }

  // We have both clip slug and scene slug results.
  const clipSceneIds = uniq(clipClips.map(clip => clip.scene_id));
  const sceneSceneIds = uniq(sceneClips.map(clip => clip.scene_id));

  const singleSceneId = intersection(clipSceneIds, sceneSceneIds);
  if (singleSceneId.length > 0) {
    // We have a winner!! Either it's 1 (likely) or it's multiple but that that point it's a coin toss anyway.
    const sceneClipsForScene = sceneClips.filter(
      clip => clip.scene_id === singleSceneId[0],
    );
    const clipClipsForScene = clipClips.filter(
      clip => clip.scene_id === singleSceneId[0],
    );

    if (clipClipsForScene.length > 1) {
      console.warn(
        'Even after filtering we come up with multiple clips for a pair of slugs. Possible duplicate clips?',
      );
    }

    return { clip: clipClipsForScene[0], sceneClips: sceneClipsForScene };
  }

  // In the event that we cannot find any overlap or common ground just use the first clipClips.
  return {
    redirect: `/browse/scene/${clipClips[0].scene_slug}/${clipClips[0]
      .clip_slug}`,
  };
}



// WEBPACK FOOTER //
// ./src/routes/browse/index.js